import { Box, HStack } from "@chakra-ui/react"
import IconButton from "@pathwright/ui/src/components/button/IconButton"
import Link from "@pathwright/ui/src/components/link/Link"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import View from "@pathwright/ui/src/components/ui/View"
import withTranslate from "@pathwright/ux/src/components/lng/withTranslate"
import * as urls from "lib/core/utils/urls"
import moment from "moment"

const tPrefix = "resource.offering_info"

const ResourceOfferingInfo = function ({ resource, offering, t }) {
  const {
    name,
    description,
    permissions,
    seats,
    seats_filled,
    access_starts,
    enrollment_ends,
    is_license_offering,
    url
  } = offering

  // caclulate on fly as offering.seats_available is updated aysncronously on backkend
  const seats_available = seats - seats_filled

  const toManage = is_license_offering
    ? `/manage/resource/${resource.id}/advanced/license/${offering.id}`
    : `/manage/group/${resource.id}/${offering.id}/`

  const cohortName = (
    <View separate>
      <h4
        className="theme-heading theme-heading-bold"
        style={{
          letterSpacing: "0",
          margin: "0"
          // textTransform: "uppercase"
        }}
        lines={1}
      >
        {name}
      </h4>
    </View>
  )

  return (
    <>
      <HStack mb="10px">
        {
          // resource license offering doesn't have a url
          url ? (
            <Link
              to={`${url}path/`}
              style={{ cursor: "pointer", flexGrow: 1, color: "inherit" }}
            >
              {cohortName}
            </Link>
          ) : (
            <div style={{ flexGrow: 1 }}>{cohortName}</div>
          )
        }
        {permissions && permissions.can_edit && (
          <IconButton
            styleType="blank"
            icon="gear"
            size={20}
            to={urls.modalRoute(toManage)}
            style={{
              marginLeft: "10px"
            }}
          />
        )}
      </HStack>
      {(!!access_starts || !!enrollment_ends || !!seats) && (
        <View
          style={{
            marginTop: "5px",
            marginBottom: "10px"
          }}
          separate
        >
          <Box py="10px">
            {!!access_starts && (
              <div>
                <Pathicon icon="calendar" /> {t(`${tPrefix}.starts`)}{" "}
                {moment(access_starts)
                  // .local()
                  .format("MMMM Do")}
              </div>
            )}
            {!!enrollment_ends && (
              <div>
                {t(`${tPrefix}.registration_closes`)}{" "}
                {moment(enrollment_ends)
                  // .local()
                  .format("MMMM Do")}
              </div>
            )}
            {!!seats && (
              <div>
                {t(`${tPrefix}.seats_left`, {
                  seat_label: t(
                    `${tPrefix}.${seats_available === 1 ? "seat" : "seats"}`
                  ),
                  seat_count: seats_available
                })}
              </div>
            )}
          </Box>
        </View>
      )}
      {!!description && (
        <View
          // paddingLeft={20}
          // paddingRight={20}
          // paddingTop={20}
          // paddingBottom={20}
          style={{
            borderTop: "none"
          }}
          // borderTop={"none"}
          separate
          className="ResourceOffering__Features"
        >
          <div dangerouslySetInnerHTML={(() => ({ __html: description }))()} />
        </View>
      )}
    </>
  )
}

ResourceOfferingInfo.displayName = "ResourceOfferingInfo"
export default withTranslate(ResourceOfferingInfo)
